"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Reason = void 0;
var Reason;
(function (Reason) {
    Reason[Reason["OwnerRequest"] = 1] = "OwnerRequest";
    Reason[Reason["RFIs"] = 2] = "RFIs";
    Reason[Reason["RecognitionOfErrorOmission"] = 3] = "RecognitionOfErrorOmission";
    Reason[Reason["Submittals"] = 4] = "Submittals";
    Reason[Reason["ReviewingAgencyRequest"] = 5] = "ReviewingAgencyRequest";
    Reason[Reason["RequestForSubstitution"] = 6] = "RequestForSubstitution";
    Reason[Reason["ImprovedInformation"] = 7] = "ImprovedInformation";
    Reason[Reason["FieldCondition"] = 8] = "FieldCondition";
    Reason[Reason["DesignDocumentChange"] = 9] = "DesignDocumentChange";
    Reason[Reason["ChangedConditions"] = 10] = "ChangedConditions";
})(Reason = exports.Reason || (exports.Reason = {}));
//# sourceMappingURL=Reason.js.map